import {Component} from 'react';
import {doubleToStringMonthly, standardNumberFormat} from '../../objects/CommonUse/double_functions';


class FinalModalCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
          open: false, 
          selected: false};
    }

    render() {
        let amountClass = "text-right p-0";
        let textClass = "text-left p-0"
        let rowClass = "";
        if (this.props.amountInfo.itemAmt < 0){
            amountClass += " text-danger";
            textClass += " text-danger"
        }
        if (this.props.amountInfo.total === true){
            textClass += " font-weight-bold pb-2"
            amountClass += " font-weight-bold pb-2";
        }
    return <>
        {+this.nbrMonths !== 0 ?
            <tr className={rowClass}>
                <td className={textClass}>{this.props.amountInfo.itemName}</td>
                <td className={textClass}>
                    {this.props.amountInfo.itemDesc}
                </td>

                {this.props.amtType === "number" ?
                    <td className={amountClass}>
                        {standardNumberFormat(this.props.amountInfo.itemAmt)}</td>
                :
                    null
                }
                {this.props.amtType === "amount" ?
                    <td className={amountClass}>
                                {doubleToStringMonthly(this.props.amountInfo.itemAmt)}</td>
                :
                    null
                }
                {this.props.amtType === "percent" ?
                    <td className={amountClass}>{this.props.amountInfo.itemAmt}%</td>
                :
                    null
                }
            </tr>
        :
            null
        }
        
    </>
    }
}

export default FinalModalCard;